export const KPI = {
    Viewability: {
        id: 0,
        key: 'Viewability',
        label: 'Viewability'
    },
    InDemo: {
        id: 1,
        key: 'InDemo',
        label: 'In-Demo'
    },
    CTR: {
        id: 2,
        key: 'CTR',
        label: 'CTR'
    },
    Performance: {
        id: 3,
        key: 'Performance',
        label: 'Performance'
    },
    CompletionRate: {
        id: 4,
        key: 'CompletionRate',
        label: 'Completion Rate'
    }
};